module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticClass: "h_label"
  }, [_vm._v("\n            " + _vm._s(_vm.titleText) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "menu",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": _vm.loadNav
    }
  })]), _vm._v(" "), _c('nav', {
    staticClass: "t-nav",
    class: {
      active: _vm.isActive
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "home",
    attrs: {
      "href": _vm.headUrl.mdd_url
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "search",
    attrs: {
      "href": _vm.headUrl.search_url
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "category",
    attrs: {
      "href": _vm.headUrl.search_url_ddcategory
    }
  }, [_vm._v("分类")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "cart",
    attrs: {
      "href": _vm.headUrl.cart_url
    }
  }, [_vm._v("购物车")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "user",
    attrs: {
      "href": _vm.headUrl.home_url
    }
  }, [_vm._v("我的当当")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7992ca12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 225
// module chunks = 3